import { GetBannersParams } from '../__generated__/gateway/Api';
import { decorateBannersForAds } from '../helpers/advertising';
import { TAdMaterialTag, TAdMaterialTagsList } from '../interfaces/advertising';
import { IMaterial } from '../interfaces/news';

import { DoubleClickClient } from './client/DoubleClickClient';
import { ProxyClient } from './client/ProxyClient';

export interface IBannersParams {
  params: GetBannersParams;
  source?: IMaterial;
  adTags?: TAdMaterialTagsList;
}

export const getBanners = async ({ params, adTags, source }: IBannersParams) => {
  const { data } = await ProxyClient.get('/banners', { params });

  return decorateBannersForAds({ banners: data, source, adTags });
};

export const getAdMaterialTags = async (): Promise<TAdMaterialTag[]> => {
  const { data } = await DoubleClickClient.get('/v1/products', {});

  return data;
};
